import {Component, Input} from '@angular/core';
import {DatasetUsageComponentObject} from "../../../../shared/classes/dataset-usage-component-object";

@Component({
  selector: 'app-custom-sources-badge-ftp',
  templateUrl: './custom-sources-badge-ftp.component.html',
  styleUrls: ['./custom-sources-badge-ftp.component.scss']
})
export class CustomSourcesBadgeFtpComponent {
  @Input() public datasource: DatasetUsageComponentObject;
}
